import { Event } from "../models/event";
import { EventViewModel } from "../models/eventViewModel";

// TODO: Replace with proper mapped fields once BE provides cleaned structure
export const mapEventEntityToViewModel = (event: Event): EventViewModel => {
  return {
    ...event,
    timestamp: event.timestamp ?? "",
    modelId: event.ddbRecord.GSIPK2?.split("#E#")[1] ?? "",
    facilityId: event.ddbRecord.GSIPK4?.split("#L#")[1] ?? "",
    mitigatedRisk: event.ddbRecord.mitigatedRisk?.split(";") ?? [],
    location: event.ddbRecord.GSIPK4,
    recordingsCount: event.ddbRecord.recordingsCount
      ? event.ddbRecord.recordingsCount
      : 0,
    leaksVolumeSum: event.ddbRecord.leaksVolumeSum
      ? event.ddbRecord.leaksVolumeSum
      : 0,
  };
};
